__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-credit'].baseUrl;
import ModuleContainer from './components/TravelCredit';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/conditional-features': '^3.4.0',
      '@americanexpress/data-manager-utils': '^0.4.2',
      '@americanexpress/one-app-module-wrapper': '^3.6.2',
      '@americanexpress/react-seo': '^2.2.0',
      '@americanexpress/reactlytics': '^1.2.6',
      '@americanexpress/travel-selectors': '^5.0.0',
      'react-intl': '^6.6.8',
      'xss': '^1.0.15'
    }
  });
}